// extracted by css-extract-rspack-plugin
export default {"wrapper":"organisation-area-groups-overlay_wrapper__M1zHG"};